export default [
  {
    path: "/projects/:id?",
    name: "projects",
    component: () => import(/* webpackChunkName: "work" */ "../views/projects/vProjectList.vue"),
    meta: { title: "Projects", auth: true, roles: [0, 10, 20] },
  },
  {
    path: "/areas/:id?",
    name: "areas",
    component: () => import(/* webpackChunkName: "work" */ "../views/areas/vAreaList.vue"),
    meta: { title: "Areas", auth: true, roles: [0, 10, 20] },
  },
  {
    path: "/tasks/:id?",
    name: "tasks",
    component: () => import(/* webpackChunkName: "work" */ "../views/tasks/vTaskList.vue"),
    meta: { title: "Tasks", auth: true, roles: [0, 10, 20] },
  },
  {
    path: "/tickets/:id?",
    name: "tickets",
    component: () => import(/* webpackChunkName: "work" */ "../views/tickets/vTicketList.vue"),
    meta: { title: "Tickets", auth: true, roles: [0, 10, 20], divisions:[0,1] },
  },
  // {
  //   path: "/staffingTickets/:id?",
  //   name: "staffingTickets",
  //   component: () => import(/* webpackChunkName: "work" */ "../views/tickets/vTicketListStaffing.vue"),
  //   meta: { title: "Staffing Tickets", auth: true, roles: [0, 10, 20], divisions:[1] },
  // },
  {
    path: "/expenses/:id?",
    name: "expenses",
    component: () => import(/* webpackChunkName: "work" */ "../views/expenses/vExpenseList.vue"),
    meta: { title: "Expenses", auth: true, roles: [0, 10, 20],  },
  },
  {
    path: "/divisions/:id?",
    name: "divisions",
    component: () => import(/* webpackChunkName: "work" */ "../views/divisions/vDivisionList.vue"),
    meta: { title: "Divisions", auth: true, roles: [10, 20] },
  },
  
];
